import React from "react";
import JobCard from "./JobCard";
import { Paper } from "material-ui";

const CardGrid = React.createClass({
  componentWillMount() {
    if (!this.props.jobs) {
      this.props.fetchJobs(this.props.token.jwt);
    }
  },

  renderJob(job, i) {
    return (
      <div key={i} style={{ marginTop: "1.5em", marginBottom: "0.75em" }}>
        <JobCard
          title={job.title}
          subTitle={job.subtitle}
          link={job.link}
          performRoute={this.props.performRoute}
          color={job.color}
          titleColor={job.title_color}
          actions={job.card_actions}
        />
      </div>
    );
  },

  render() {
    return (
      <Paper
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
      >
        {this.props.jobs.map(this.renderJob)}
      </Paper>
    );
  },
});

export default CardGrid;



// WEBPACK FOOTER //
// ./app/components/CardGrid.js